export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_ALL_COMPETENCY = "GET_ALL_COMPETENCY";
export const UPDATE_USER_PERSONAL_INFO = "UPDATE_USER_PERSONAL_INFO";
// export const GET_STUDENT_COUNT = "GET_STUDENT_COUNT";
// export const GET_TEACHER_COUNT = "GET_TEACHER_COUNT";
export const GET_DASHBOARD_COUNT = "GET_DASHBOARD_COUNT";
export const GET_CONFIG_SETTINGS = "GET_CONFIG_SETTINGS";
export const CONFIG_ERROR_GENERATED = "CONFIG_ERROR_GENERATED";